module.exports = __webpack_public_path__ + "static/img/img2.2d3c8cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img2.jpg
// module id = kNVX
// module chunks = 0